import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.buttonTag, _vm._g(_vm._b({
    tag: "component",
    staticClass: "v-icon-btn",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "disabled": _vm.disabled || _vm.loading,
      "type": _vm.buttonType
    }
  }, 'component', _vm.$attrs, false), _vm.$listeners), [_c('span', {
    key: "content",
    staticClass: "v-icon-btn__content"
  }, [_vm._t("default", null, {
    "color": "current"
  })], 2), _vm._v(" "), _vm.loading ? _c('span', {
    key: "loader",
    staticClass: "v-icon-btn__loader"
  }, [_c('CircularLoader', {
    attrs: {
      "color": "current",
      "size": "1.125em"
    }
  })], 1) : _vm._e()]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-121a348a_0", {
    source: ".v-icon-btn[data-v-121a348a]{background:0 0;border-radius:50%;color:var(--c-color);cursor:pointer;padding:.4em;border:0;transition:ease var(--g-transition-speed);transition-property:background-color,color,opacity;display:inline-flex;position:relative;font-size:var(--c-size);overflow:hidden}.v-icon-btn[data-v-121a348a]:focus,.v-icon-btn[data-v-121a348a]:hover{background:var(--c-bg-color)}.v-icon-btn[data-v-121a348a]:active{background:var(--c-bg-color-active);transform:scale(.98)}.v-icon-btn--filled[data-v-121a348a]{color:var(--c-active-color);background-color:var(--c-bg-color)}.v-icon-btn--filled[data-v-121a348a]:focus,.v-icon-btn--filled[data-v-121a348a]:hover{background-color:var(--c-bg-color-active)}.v-icon-btn[data-v-121a348a]:disabled:not(.v-icon-btn--loading),.v-icon-btn[disabled][data-v-121a348a]:not(.v-icon-btn--loading){background-color:var(--c-disabled-bg-color);border-color:var(--c-disabled-bg-color);color:var(--c-disabled-color);opacity:.75;pointer-events:none;transform:none}.v-icon-btn--loading[data-v-121a348a]{background:var(--c-disabled-bg-color);color:var(--c-disabled-color);cursor:default}.v-icon-btn--loading .v-icon-btn__content[data-v-121a348a]{visibility:hidden}.v-icon-btn__content[data-v-121a348a]{display:flex}.v-icon-btn__content>svg[data-v-121a348a]{height:1em;width:1em}.v-icon-btn__loader[data-v-121a348a]{background:var(--c-disabled-bg-color);align-items:center;display:flex;left:0;height:100%;justify-content:center;position:absolute;top:0;width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-121a348a";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var IconButton = __vue_component__;
export { IconButton as default };